import { __assign } from "tslib";
import ddt from '@wix/da-ddt';
var logger = ddt.createLogger('flags');
export function isFlagEnabled(flags, condition) {
    if (!flags) {
        logger.error('No flags object passed');
        return false;
    }
    if (typeof condition === 'string') {
        return !!flags[condition];
    }
    return condition(flags);
}
export function isAnyFlagEnabled(flags, conditions) {
    if (!flags) {
        logger.error('No flags object passed');
        return false;
    }
    return conditions.some(function (flag) { return !!flags[flag]; });
}
export function getEnabledFlagList(flags) {
    if (!flags) {
        logger.error('No flags object passed');
        return [];
    }
    return Object.keys(flags).filter(function (flag) { return !!flags[flag]; });
}
/**
 * Converts the features array into features object
 */
export function flagsFromSession(features) {
    if (!features) {
        return {};
    }
    return features.reduce(function (o, feature) {
        var _a;
        return (__assign(__assign({}, o), (_a = {}, _a[feature] = true, _a)));
    }, {});
}
export function addCalculatedFlags(source) {
    if (!source) {
        logger.error('No flags object passed');
        return {};
    }
    return __assign({}, source);
}
//# sourceMappingURL=helpers.js.map